import { HotelCard } from "@website/accommodation-ui/hotel-card-new";
import { CountDownTimer } from "@website/accommodation-ui/hotel-last-second/count-down-timer";
import { HotelLastSecondCityPagePropertiesTypes } from "@website/accommodation-ui/hotel-last-second/hotel-last-second-city-page/hotel-last-second-city-page.type";
import { CarouselV2 } from "@website/ui/carousel";
import { Skeleton } from "@website/ui/skeleton";
import { today, tomorrow } from "@website/utils/date-format";
import { deepCompare } from "@website/utils/deep-compare";
import set from "lodash-es/set";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
import { FC, memo } from "react";

const Component: FC<HotelLastSecondCityPagePropertiesTypes> = ({
  lastSecondHotels,
  loading,
  cityTitle
}) => {
  const router = useRouter();
  if (
    router.query["promotion"] ||
    !lastSecondHotels?.length ||
    ![today(), tomorrow()].includes(toString(router.query["date_from"]))
  ) {
    return;
  }

  return (
    <div className="bg-transparent-primary border-transparent-primary mx-[-24px] flex flex-col gap-4 border-y px-6 pb-6 pt-4 xl:mx-0 xl:rounded-xl xl:border">
      {loading ? (
        <div className="flex flex-col gap-4">
          <div className="flex h-[64px] flex-col md:h-[28px] md:flex-row md:justify-between">
            <Skeleton className="!w-[112px]" shape="rectangle" />
          </div>
          <Skeleton className="!w-full" height={112} shape="rectangle" />
        </div>
      ) : (
        <>
          <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between md:gap-4">
            <div className="flex flex-row items-center gap-2">
              <h2 className="text-subtitle-2 text-primary">{`آخرین فرصت‌های اقامت در ${cityTitle}`}</h2>
            </div>
            <CountDownTimer
              chipClassName="!h-[32px] pr-1 md:!h-[28px] md:gap-[6px]"
              className="flex gap-1 md:gap-0"
              resetOnEnd
              showTimer={!loading}
              textWrapperClassName="text-body-1 md:text-body-2 text-on-color-high-emphasis gap-3 md:gap-1"
              wrapperClassName="md:w-[143px]"
            />
          </div>
          <div className="h-auto">
            <CarouselV2
              itemClass="max-w-[280px] px-2"
              keyCarousel={`suggested_cities_carousel_${cityTitle}`}
              list={
                lastSecondHotels?.map((hotel, index) => (
                  <HotelCard
                    index={index}
                    hotelInfo={set(
                      hotel,
                      "hotelDetail.hotelPageUrl.query.utm_source",
                      "last_second_hotels"
                    )}
                    key={hotel.id}
                    loading={loading}
                    isSuggestedCard
                    size="xSmall"
                  />
                )) || []
              }
              mode="free"
              options={{ slides: { perView: "auto" } }}
            />
          </div>
        </>
      )}
    </div>
  );
};
export const HotelLastSecondCityPage = memo(Component, deepCompare);
